import useApplicationStore from "../../../state/ApplicationStore";
import DynamicText from "../../common/DynamicText";
import { useState } from "react";
import { Pill, FormattedValue, Button, FilterModal } from "frno-react";
import useTextStore from "../../../state/TextStore";
import Sidebar from "../Sidebar";
import { TableType } from "../../../data/TableType";

import "./mobilesidebar.scss";

type MobileSidebarProps = {
  pensionType: string;
  tableType: TableType;
};
export default function MobileSidebar({
  pensionType,
  tableType,
}: MobileSidebarProps) {
  const { savingsValue, selectedRisk, selectedReturnPeriod } =
    useApplicationStore();

  const { getTextByKey } = useTextStore();
  const [modalIsOpen, toggleModal] = useState(false);

  return (
    <div className="mobile-filter mt-4">
      <Button
        onClick={() => toggleModal(!modalIsOpen)}
        className="btn-featured btn-sm"
        icon="fa-sliders"
      >
        <DynamicText textKey="filter.button" />
      </Button>

      <div className="flex-wrap align-center rg-3 cg-2">
        <Pill content={pensionType}></Pill>
        <Pill content={<FormattedValue value={savingsValue} postfix="kr" />} />
        <Pill content={tableType} />
        {tableType === TableType.SAVINGSPROFILES && (
          <>
            <Pill
              content={
                <DynamicText
                  textKey="filter.mobile.label.risk"
                  replaceComponent={`${selectedRisk.min} - ${selectedRisk.max}`}
                />
              }
            />
            <Pill
              content={
                <DynamicText
                  textKey="filter.mobile.label.return"
                  replaceComponent={
                    <FormattedValue value={selectedReturnPeriod} postfix="år" />
                  }
                />
              }
            />
          </>
        )}
      </div>

      {modalIsOpen && (
        <FilterModal
          header={<DynamicText textKey="filter.modal.header" />}
          ariaLabelText={getTextByKey("filter.modal.aria-close")}
          closeModal={() => toggleModal(false)}
        >
          <Sidebar className="mobile" idPrefix="mobile-" />
        </FilterModal>
      )}
    </div>
  );
}
